import { mediaData } from '@/mocks/homeData';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          视频深扒
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">深度解析娱乐圈争议事件的来龙去脉</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item, i) => (
            <div key={i} className="bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-accent-300 transition-all cursor-pointer group">
              <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 left-2 flex items-center gap-2">
                  <span className="bg-accent-500 text-white text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                  <i className="ri-play-fill text-accent-600 text-sm"></i>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 leading-snug group-hover:text-accent-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1.5">{item.views} 次观看</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}